/** XRPT01 2.8/3.25 and XRPT05 2.9/3.31: refused share must not leave the clinic. */
export const LAB_CONSENT_REFUSED_DOCUMENT_TAG = 'lab-consent-refused';

export function labConsentAllowsShare(
  consentGiven: boolean | null | undefined,
): boolean {
  return consentGiven !== false;
}
